import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';
import { SetAssignAdminModal } from '../../modals/SetAssignAdminModal/SetAssignAdminModal';

export const AssignAdminForm = ({ id, formRef, updateAssignAdminModalVisible, users, onConfirmSwitchAdmin, onCancel }) => (
  <Formik
    innerRef={formRef}
    enableReinitialize
    validateOnMount
    initialValues={{
      admin: '',
    }}
    validationSchema={Yup.object().shape({
      admin: Yup.string().trim().required('*required'),
    })}
    onSubmit={async (values, { resetForm, setSubmitting }) => {
      try {
        await onConfirmSwitchAdmin({ organizationId: id, userId: values.admin });
        resetForm();
      } catch (error) {
        setSubmitting(false);
      }
    }}>
    {({ isValid, handleSubmit, resetForm }) => {
      return (
        <form onSubmit={handleSubmit}>
          <SetAssignAdminModal
            title='Switch Admin for this Organization'
            visible={updateAssignAdminModalVisible}
            onCancel={onCancel(resetForm)}
            isValid={isValid}
            users={users}
          />
        </form>
      );
    }}
  </Formik>
);
